import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdicionaisEDescontosInserirRoutingModule } from './adicionais-e-descontos-inserir-routing.module';
import { AdicionaisEDescontosInserirComponent } from './adicionais-e-descontos-inserir.component';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';


@NgModule({
  declarations: [
    AdicionaisEDescontosInserirComponent
  ],
  imports: [
    CommonModule,
    AdicionaisEDescontosInserirRoutingModule,
    FormsModule,
    InputTextModule,
    DividerModule,
    MessagesModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule
  ]
})
export class AdicionaisEDescontosInserirModule { }
